import { render, staticRenderFns } from "./AdjustLabel.vue?vue&type=template&id=62474587&"
import script from "./AdjustLabel.vue?vue&type=script&lang=js&"
export * from "./AdjustLabel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports